/**
 * Consistent empty state card: icon + title + optional description + optional CTA.
 */
export function EmptyState({ icon: Icon, title, description, cta, testId = "empty-state", className = "" }) {
  return (
    <div className={`border border-[var(--pf-border)] p-12 text-center ${className}`} data-testid={testId}>
      {Icon && <Icon className="w-10 h-10 text-[var(--pf-text-muted)] mx-auto mb-3" />}
      {title && <p className="text-sm font-medium text-[var(--pf-text)] mb-1">{title}</p>}
      {description && <p className="text-xs text-[var(--pf-text-secondary)] max-w-md mx-auto">{description}</p>}
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
